
<script>

    import {visitors} from './stores.js';
    
</script>


<div class="contentBox">

    <h1>About</h1>

    <h2>How does this work?</h2>

    <p>
        It's a canvas where everyone can draw on online in real time, 
        that saves itself every few hours after someone touches the canvas. 
        (yes, you should never leave the canvas empty as in hurts my feelings). 
        You can see when that time is by going to the Board tab and searching for TIME TILL SNAPSHOT. 
        In the snapshot section you can see previous drawings. Have fun!
    </p>

    <h2>How many people visited this site?</h2>

    <p>
       {$visitors}
    </p>


    <h2>Updates</h2>
    
    <p>Here's where you can read about all the <a href="https://drawboardcafe.neocities.org/updates.html">updates</a> and their dates this site recieved</p>

    <h2>Link back</h2>

    <p>You can link back to me using either one of those urls</p>

    <p class="linkBack">https://www.drawboard.cafe/</p>

    <p>or</p>

    <p class="linkBack">https://drawboardcafe.neocities.org/</p>

    <p>My button is here </p>

    <img src="https://drawboardcafe.neocities.org/button.gif">

    <h2>Don't forget...</h2>

    <p>To check out <a href="https://drawboardcafe.neocities.org/links.html">these cool sites</a>, and also take a look at <a href="https://drawboardcafe.neocities.org/credits.html">the credits</a> for drawings others made for this site's background.</p>

    <h2>Contact</h2>

    <p>you can mail me at <strong>filthysaucer404[at]tutanota[dot]com </strong></p>

</div>


<style>

    .contentBox{
        padding: 25px;
    }

    .linkBack{
        background-color: white;
        width: min-content;
        padding: 3px;
    }

</style>